export default __webpack_public_path__ + "static/media/arrow-down-right-red.f2d59277.svg";